import ApiService from "@/core/services/api.service";

const _ = require('lodash');
export const GET_DEVICE_VERIFICATION = "GET_DEVICE_VERIFICATION";

const state = {};

const getters = {};

const actions = {
    [GET_DEVICE_VERIFICATION](context, credentials) {
        return new Promise((resolve,reject) => {
            ApiService.query("citime/auth-request", credentials)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    },
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};
